module.exports = __webpack_public_path__ + "static/media/intro-en-de.b603744c.vtt";